import { render, staticRenderFns } from "./RecordModal.vue?vue&type=template&id=6dc074d3&"
import script from "./RecordModal.vue?vue&type=script&lang=js&"
export * from "./RecordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports